// Full-cube face geometry (ENG-13, shape library seed). One entry per face with
// its direction, tangent axis, directional shade, and 4 corner positions+UVs.
// Ported verbatim from the legacy engine so meshing keeps pixel/AO parity; the
// non-cube shapes (slab/stairs/…) join this library in M2/M10.

export interface FaceCorner {
  pos: readonly [number, number, number];
  uv: readonly [number, number];
}

export interface CubeFace {
  /** Face normal / neighbor direction. */
  dir: readonly [number, number, number];
  /** Axis the face is perpendicular to (0=x,1=y,2=z) — used for AO tangents. */
  axis: 0 | 1 | 2;
  /** Baked directional brightness (top brightest, bottom darkest). */
  shade: number;
  /** CCW corner order paired with the (0,1,2)(2,1,3) index pattern. */
  corners: readonly [FaceCorner, FaceCorner, FaceCorner, FaceCorner];
}

export const CUBE_FACES: readonly CubeFace[] = [
  { dir: [-1, 0, 0], axis: 0, shade: 0.75, corners: [
    { pos: [0, 1, 0], uv: [0, 1] }, { pos: [0, 0, 0], uv: [0, 0] },
    { pos: [0, 1, 1], uv: [1, 1] }, { pos: [0, 0, 1], uv: [1, 0] }] },
  { dir: [1, 0, 0], axis: 0, shade: 0.75, corners: [
    { pos: [1, 1, 1], uv: [0, 1] }, { pos: [1, 0, 1], uv: [0, 0] },
    { pos: [1, 1, 0], uv: [1, 1] }, { pos: [1, 0, 0], uv: [1, 0] }] },
  { dir: [0, -1, 0], axis: 1, shade: 0.55, corners: [
    { pos: [1, 0, 1], uv: [1, 0] }, { pos: [0, 0, 1], uv: [0, 0] },
    { pos: [1, 0, 0], uv: [1, 1] }, { pos: [0, 0, 0], uv: [0, 1] }] },
  { dir: [0, 1, 0], axis: 1, shade: 1.0, corners: [
    { pos: [0, 1, 1], uv: [1, 1] }, { pos: [1, 1, 1], uv: [0, 1] },
    { pos: [0, 1, 0], uv: [1, 0] }, { pos: [1, 1, 0], uv: [0, 0] }] },
  { dir: [0, 0, -1], axis: 2, shade: 0.85, corners: [
    { pos: [1, 0, 0], uv: [0, 0] }, { pos: [0, 0, 0], uv: [1, 0] },
    { pos: [1, 1, 0], uv: [0, 1] }, { pos: [0, 1, 0], uv: [1, 1] }] },
  { dir: [0, 0, 1], axis: 2, shade: 0.85, corners: [
    { pos: [0, 0, 1], uv: [0, 0] }, { pos: [1, 0, 1], uv: [1, 0] },
    { pos: [0, 1, 1], uv: [0, 1] }, { pos: [1, 1, 1], uv: [1, 1] }] },
];
